export default __webpack_public_path__ + "static/media/7.3829b530.jpg";